module.exports = __webpack_public_path__ + "img/fighting_against_e.fea401d8.jpg";